export abstract class JSONItemBase{
    public Type:string;
    constructor() {
        this.Type=this.GetType();
    }

    public abstract GetType();
}